import { useMemo } from "react";
import { useAuth } from "../contexts/AuthContext";
import { getDecodedToken, isJwtExpired } from "../utils/jwtUtils";
import {
  checkRouteAccess,
  type RouteAccessKind,
} from "../utils/routeAccess";

function resolveUserRoles(userRoles?: string[] | null): string[] | undefined {
  if (userRoles?.length) return userRoles;
  return getDecodedToken()?.roles;
}

export function useRouteAccess(access: RouteAccessKind): boolean {
  const { token, user } = useAuth();

  return useMemo(() => {
    return checkRouteAccess(access, {
      roles: resolveUserRoles(user?.roles),
      hasToken: Boolean(token) && !isJwtExpired(token),
    });
  }, [access, token, user?.roles]);
}
